module.exports = __webpack_public_path__ + "img/Physicians-background-gray.302c8974.svg";